@if (menuConfig; as config) {
  <div class="menu">
    <div class="menu__left">
      <!-- Selected Product/Site-->
      @if (config.activeApp?.name !== ECODESIGN_BUILDER.app_name) {
        @if (config.activeEntity) {
          <button
            mat-button
            [attr.aria-label]="config.activeEntity.name"
            [matMenuTriggerFor]="getMenuReference(config.activeEntity.menuTrigger)"
            tabindex="0"
            #activeEntity="matMenuTrigger"
            [attr.data-expanded]="activeEntity.menuOpen"
          >
            <mds-menu-nav-block
              [attr.data-testid]="config?.activeEntity?.name"
              [menu]="config.activeEntity"
              [borderLeftColor]="typeColorMap[config?.activeEntity?.type ?? 'default']"
              [isArrowRight]="true"
              class="menu__nav-block"
              style="height: 100%"
            ></mds-menu-nav-block>
          </button>
        }

        <!--  App block  -->
        @if (config.activeApp && config.activeApp.menuTrigger !== 'selectImports') {
          <app-apps-menu
            class="menu__nav-block"
            style="height: 100%"
            [activeApp]="config.activeApp"
            (appClick)="openAppModal($event)"
          ></app-apps-menu>
        }
      } @else {
        @if (config.activeApp) {
          <app-apps-menu
            class="menu__nav-block"
            style="height: 100%"
            [activeApp]="config.activeApp"
            (appClick)="openAppModal($event)"
          ></app-apps-menu>

          <mds-menu-nav-block
            [attr.data-testid]="config.activeEntity?.name"
            [menu]="config.activeEntity"
            [isArrowRight]="!!config.additionalActiveEntity?.name"
            [isDropdown]="false"
            (click)="onMenuAction({ key: 'home' })"
            class="menu__nav-block"
            style="height: 100%"
          ></mds-menu-nav-block>

          <mds-menu-nav-block
            [attr.data-testid]="config?.additionalActiveEntity?.name"
            [menu]="config.additionalActiveEntity"
            [isArrowRight]="false"
            [isDropdown]="false"
            class="menu__nav-block"
            style="height: 100%"
          ></mds-menu-nav-block>
        }
      }
      @if (config.activeApp && config.activeApp.menuTrigger === 'selectImports') {
        <!-- Importers -->
        <app-apps-menu
          class="menu__nav-block"
          style="height: 100%"
          [activeApp]="config.activeApp"
          [searchPlaceholder]="'Search for an importer...'"
          [customItemsList]="importApps$ | async"
          (appClick)="openAppModal($event)"
        ></app-apps-menu>
      }
      @if (menuConfig?.additionalActiveEntity?.menuTrigger === 'selectReport') {
        <!-- Pivot manager/reports -->
        <app-report-menu [activeApp]="config.additionalActiveEntity"></app-report-menu>
      }
      @if (menuConfig?.additionalActiveEntity?.menuTrigger === 'selectAdvanceImports') {
        <!-- Advanced import -->
        <app-apps-menu
          class="menu__nav-block"
          style="height: 100%"
          [activeApp]="config.additionalActiveEntity"
          [searchPlaceholder]="'Search for an importer...'"
          [customItemsList]="advanceImportApps"
          (appClick)="openAdvanceAppModal($event)"
        ></app-apps-menu>
      }
      <!--    TODO move to Additional Entity -->
      @if (chemicalGrading) {
        <button
          mat-button
          aria-label="Chemical grading"
          [matMenuTriggerFor]="searchRSL"
          tabindex="0"
          #rsl="matMenuTrigger"
          [attr.data-expanded]="rsl.menuOpen"
        >
          <mds-menu-nav-block [menu]="rslPinMenu" class="menu__nav-block pointer"></mds-menu-nav-block>
        </button>
      }
    </div>

    <div class="menu__center">
      @for (action of config.centerActions; track action) {
        @if (action.visible) {
          <mds-menu-tool
            [attr.data-testid]="action.label"
            [action]="action"
            [matTooltip]="!action.disabled ? action.tooltip : null"
            (click)="!action.disabled ? onMenuAction(action) : null"
            [matMenuTriggerFor]="
              action.menuTrigger && !action.disabled ? getMenuReference(action.menuTrigger, action) : null
            "
          ></mds-menu-tool>
        }
      }
    </div>

    <div class="menu__right">
      <div class="menu__actions">
        @for (action of config.rightActions; track action) {
          @if (action.visible && !action?.dropdown) {
            <mds-menu-tool
              [attr.data-testid]="action.label"
              [action]="action"
              (click)="!action.disabled ? onMenuAction(action) : null"
              [matTooltip]="!action.disabled ? action.tooltip : null"
              [matMenuTriggerFor]="
                action.menuTrigger && !action.disabled ? getMenuReference(action.menuTrigger, action) : null
              "
            >
              @if (activePinCount && action.key == 'pins') {
                <mds-badge
                  style="transform: translate(0%, 32%)"
                  #additionalData
                  [value]="activePinCount"
                  size="medium"
                  [overlap]="true"
                  type="circle"
                  position="above"
                >
                  <mds-icon
                    [key]="action.icon"
                    [width]="24"
                    [height]="24"
                    [pathColors]="action.disabled ? [lightGray] : [whiteColor]"
                  ></mds-icon>
                </mds-badge>
              }
            </mds-menu-tool>
          }
          <!-- To add dropdown in action button, send 'dropdown' true and list of dropdwn options-->
          @if (action.visible && action?.dropdown) {
            <mds-menu-tool [action]="action" [matMenuTriggerFor]="menuItem"></mds-menu-tool>
            <mat-menu #menuItem="matMenu">
              @for (filter of action['list']; track filter) {
                <button
                  [attr.aria-label]="filter['value']"
                  role="menuitem"
                  (click)="!action.disabled ? onMenuAction(filter) : null"
                  class="apply-filter"
                  mat-menu-item
                  fxLayout="row"
                  fxLayoutAlign="start center"
                >
                  <div>{{ filter['value'] }}</div>
                </button>
              }
            </mat-menu>
          }
        }
      </div>
    </div>
  </div>
}

<mat-menu #uploadMenu="matMenu" class="upload-menu">
  <ng-template matMenuContent>
    @for (item of uploadMenuDropdown; track item) {
      <div mat-menu-item class="menu-item" (click)="onSelectedUpload(item)">
        <mds-icon [key]="item.icon" [width]="20" [height]="20"></mds-icon>
        {{ item.value }}
        <mds-icon
          [matTooltip]="item.info"
          matTooltipHideDelay="300"
          [key]="icons.INFO"
          [width]="16"
          [height]="16"
        ></mds-icon>
      </div>
    }
  </ng-template>
</mat-menu>
<mat-menu #searchRSL="matMenu" class="rsl-panel">
  <div role="menuitem" (click)="$event.stopPropagation(); $event.preventDefault()" class="rsl-panel-div">
    <h6>Search or change the applied RSL pin</h6>
    <div mdsInlineFormSchema (openMenuItem)="openMenuItem($event)" [schema]="schema" style="width: 100%"></div>
    @if (pinsData.length) {
      <table>
        <tr>
          <th>Applied</th>
          <th colspan="2">Pin</th>
        </tr>
        @for (pin of pinsData; track pin; let in = $index) {
          <tr>
            <td>
              <mat-radio-button
                aria-label="select filter"
                name="select filter"
                (click)="applyPin(pin)"
                [checked]="pin.checkbox"
              ></mat-radio-button>
            </td>
            <td>{{ pin.label }}</td>
            <td>
              <button tabindex="0" aria-label="remove filter" (click)="removePin(pin)">
                <mds-icon [key]="closeIcon" [pathColors]="closeButtonColor" [width]="20" [height]="20"></mds-icon>
              </button>
            </td>
          </tr>
        }
      </table>
    }
  </div>
</mat-menu>

<mat-menu #productDetailForAI="matMenu">
  <button mat-menu-item class="product-details" (click)="onClickProductDetails()" aria-label="Product Details">
    <mds-icon [key]="icons.INFO" [pathColors]="['#547080']"></mds-icon>

    <span class="menu-item-text">Product Details</span>

    <span class="menu-item-spacer"></span>

    <mds-icon [key]="icons.CHEVRON_RIGHT_2" [pathColors]="['#547080']"></mds-icon>
  </button>
</mat-menu>

<mat-menu #moreMenuOptions="matMenu">
  @for (section of menuOptions; track section) {
    @if (section.sectionTitle) {
      <div>
        <div class="section-title">{{ section.sectionTitle }}</div>
        <div class="section-space"></div>
      </div>
    }
    @for (item of section.items; track item) {
      <mds-menu-dropdown-item
        (click)="item.isDisabled ? $event.stopPropagation() : onClickMenuOption(item)"
        [attr.aria-label]="item.title"
        [icon]="item.icon"
        [indicator]="item?.indicator"
        [title]="item.title"
        [isDisabled]="item.isDisabled"
        tabindex="0"
        [attr.data-testid]="item.title"
      ></mds-menu-dropdown-item>
    }
  }
</mat-menu>
